import * as React from 'react';
import { Panel, PanelType } from '@fluentui/react';
import { Text, Card, CardHeader, Button, Spinner } from '@fluentui/react-components';
import { ContractStageType } from '../../../../models/Entities/Contracts/ContractStageType';
import * as ComponentFunctions from './StageTypeList.Functions';
import { connect } from 'react-redux';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StageTypeFormComponent from '../StageTypeForm/StageTypeForm.Component';
import { Edit20Regular, Delete20Regular } from '@fluentui/react-icons';
import ConfirmDialog from '../../../../commons/component/ConfirmDialog/ConfirmDialog';

const StageTypeListComponent = (props: any) => {
    const { isOpen, dismissPanel, ContractStageTypes } = props;
    const [showForm, setShowForm] = useState(false);
    const [editingStageType, setEditingStageType] = useState<ContractStageType | null>(null);
    const [deletingId, setDeletingId] = useState<number | null>(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmItem, setConfirmItem] = useState<ContractStageType | null>(null);
    const { t } = useTranslation();

    const openConfirm = (item: ContractStageType) => {
        setConfirmItem(item);
        setConfirmOpen(true);
    };

    const handleConfirmDelete = () => {
        if (confirmItem) {
            setDeletingId(confirmItem.id);
            if (props.DeleteContractStageType) {
                Promise.resolve(props.DeleteContractStageType(confirmItem.id)).finally(() => setDeletingId(null));
            } else {
                setDeletingId(null);
            }
        }
        setConfirmOpen(false);
        setConfirmItem(null);
    };

    const handleCancelDelete = () => {
        setConfirmOpen(false);
        setConfirmItem(null);
    };

    const onRenderFooterContent = () => (
        <div style={{ display: 'flex' }}>
            <Button appearance="secondary" onClick={dismissPanel}>
                Cerrar
            </Button>
        </div>
    );

    return (
        <Panel
            isOpen={isOpen}
            onDismiss={dismissPanel}
            type={PanelType.medium}
            headerText="Listado de tipos de etapa"
            isFooterAtBottom={true}
            onRenderFooterContent={onRenderFooterContent}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
                <div style={{ flex: '1 1 auto', overflowY: 'auto', paddingBottom: 72 }}>
                    <Button appearance="primary" style={{ marginBottom: 16 }} onClick={() => { setShowForm(true); setEditingStageType(null); }}>
                        Agregar nuevo tipo de etapa
                    </Button>
                    {showForm && (
                        <StageTypeFormComponent
                            dismissPanel={() => { setShowForm(false); setEditingStageType(null); }}
                            isOpen={showForm}
                            StageTypeId={editingStageType?.id || undefined}
                            openPanel={function (): void {
                                throw new Error('Function not implemented.');
                            }}
                        />
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {ContractStageTypes && ContractStageTypes.length > 0 ? (
                            ContractStageTypes.map((stageType: ContractStageType) => (
                                <Card
                                    key={stageType.id}
                                    style={{ border: '1px solid #ccc', position: 'relative', opacity: deletingId === stageType.id ? 0.6 : 1 }}
                                    onClick={e => {
                                        e.stopPropagation();
                                        setEditingStageType(stageType);
                                        setShowForm(true);
                                    }}
                                >
                                    <CardHeader
                                        header={<Text weight="semibold">{stageType.name}</Text>}
                                        description={stageType.description || ''}
                                    />
                                    {deletingId === stageType.id && (
                                        <div style={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}>
                                            <Spinner size="tiny" label="Eliminando..." />
                                        </div>
                                    )}
                                    <Button
                                        appearance="subtle"
                                        style={{ position: 'absolute', top: 8, right: 8, color: 'red', zIndex: 3 }}
                                        disabled={deletingId === stageType.id}
                                        onClick={e => {
                                            e.stopPropagation();
                                            openConfirm(stageType);
                                        }}
                                    >
                                        <Delete20Regular />
                                    </Button>
                                </Card>
                            ))
                        ) : (
                            <Text>No hay tipos de etapa disponibles.</Text>
                        )}
                    </div>
                </div>
                <ConfirmDialog
                    open={confirmOpen}
                    title={t('confirmDialog.deleteTitle', 'Confirmar eliminación')}
                    message={t('confirmDialog.deleteMessage', 'Esta acción no se puede deshacer.')}
                    highlight={confirmItem?.name || ''}
                    confirmText={t('commons.confirmationModal.confirm', 'Confirmar')}
                    cancelText={t('commons.confirmationModal.cancel', 'Cancelar')}
                    onConfirm={handleConfirmDelete}
                    onCancel={handleCancelDelete}
                />
            </div>
        </Panel>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(StageTypeListComponent as any);
